import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2IssueCommentAttachment } from '@/api/model/interfaces';

export default class PackageKS2IssueCommentAttachmentOdata extends OdataManager<PackageKS2IssueCommentAttachment> {}
